<template>
  <div >
    <tgosMap />
  </div>
</template>

<script>
// import tgosMap from '@/views/common/_tgosMap'
import tgosMap from '@/views/common/openLayersMap'
// import tgosMap from '@/views/common/tgosMap'


export default {
    // 監測圖台
    name: 'MonitorMap',
    components: {
        tgosMap
    },
    data() {
        return {
        
        };
    },
    async created()
    {

    },
    mounted()
    {
        "/api/system/profile/gps"
    },
  methods:
    {
        toProfileGroupList()
        {
            this.$router.push({
                name: '用戶清單',
            })
        }
    }
}
</script>